import React, { useEffect, useState } from "react";
import { ClipboardList, RefreshCcw } from "lucide-react";
import api, { apiErrorMessage } from "@/lib/api";

export default function AdminAuditFeed() {
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const reload = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await api.get("/admin/audit-feed", { params: { action: filter, limit: 200 } });
      setEvents(data.events);
    } catch (e) { setErr(apiErrorMessage(e)); } finally { setBusy(false); }
  };
  useEffect(() => { reload(); }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="admin-audit-feed" className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow flex items-center gap-2"><ClipboardList className="h-3 w-3" /> Audit</div>
        <h1 className="headline-xl">Audit feed</h1>
        <p className="text-lifted-dim mt-2 text-sm">Every mutation across users, training, affiliate, delivery, partner, franchise, brand assets — time-stamped.</p>
      </header>

      <div className="flex gap-2 flex-wrap items-center">
        <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="filter by action (regex)…"
               className="input-lifted text-sm flex-1 min-w-[200px]" data-testid="audit-feed-filter-input" />
        <button onClick={reload} disabled={busy} className="btn-lifted" data-testid="audit-feed-refresh"><RefreshCcw className="h-3 w-3" /> {busy ? "…" : "Reload"}</button>
      </div>

      {err && <div className="text-rose-300 text-sm">{err}</div>}

      <section className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">When</th><th>Action</th><th>Actor</th><th>Target</th><th>Meta</th>
            </tr>
          </thead>
          <tbody>
            {events.map((e) => (
              <tr key={e.id} data-testid={`audit-feed-event-${e.id}`} className="border-b border-white/5">
                <td className="px-4 py-2 text-xs text-lifted-dim whitespace-nowrap">{e.created_at?.slice(0,19).replace("T"," ")}</td>
                <td className="text-lifted-text"><span className="chip">{e.action}</span></td>
                <td className="text-xs text-lifted-dim">{e.actor_id?.slice(0, 12)}…</td>
                <td className="text-xs text-lifted-dim">{e.target_id ? `${e.target_id.slice(0, 12)}…` : "—"}</td>
                <td className="text-xs text-lifted-dim max-w-md truncate" title={JSON.stringify(e.meta || {})}>{JSON.stringify(e.meta || {})}</td>
              </tr>
            ))}
            {events.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-lifted-mute">No audit events match.</td></tr>}
          </tbody>
        </table>
      </section>
    </div>
  );
}
